export default __webpack_public_path__ + "static/media/Coffee-video.0f20c3f9.mp4";